import {
  properCallApi,
  type ApiRequest,
  type ApiResponseSingle
} from '@/api/tenantClient';
import { type Registration } from './registration';

export const registrationUpsellQueryKey = 'registration.registrationUpsell';

export function registrationUpsell(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (params: { eventId: string }): Promise<ApiResponseSingle<Registration>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/registration_upsell';
    request.payload = {
      event_id: params.eventId
    };

    return await properCallApi<ApiResponseSingle<Registration>>(request);
  };
};

export interface RegistrationUpsellCompleteRequest {
  registrationId: number
}

export function completeRegistrationUpsell(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: RegistrationUpsellCompleteRequest
  ): Promise<ApiResponseSingle<Registration>> => {
    request.method = 'POST';
    request.endpoint.path = `/api/v1/registration_upsell/${params.registrationId}/complete`;

    return await properCallApi<ApiResponseSingle<Registration>>(request);
  };
};
